import { Layout } from 'ant-design-vue'
import { createNamespacedHelpers ,mapActions } from 'vuex'
const { Header,Content,Footer } = Layout;
import { util } from '@utils'
import TopBar from '@components/topBar'
import Banner from './components/banner'
import About from './components/about'
import Timeline from './components/timeline'
import Enter from './components/enter'
import Serve from './components/serve'
import Partner from './components/partner'
import FootBar from '@components/footBar'
import Entry from './components/entry'
import Wrap from './components/wrap/new'
import Why from './components/why'
import Milestone from './components/milestone'

const { mapState,mapMutations } = createNamespacedHelpers('pages/home')
const components = { Layout,Header,Content,Footer,TopBar,Banner,About,Timeline,Enter,Serve,Partner,FootBar,Wrap, Entry, Why, Milestone }
export default {
    components,
    data(){
      return {
        cms:{
          ad: [],
          settled_list: [],
          about_data: [],
          timeline: [],
          service_list: [],
          partner_list: []
        }
      }
    },
    created(){
      this.getCms();
    },
    mounted(){
      util.$tracker(149, '288916',10000);
      this.getUserInfo();
      //this.$nextTick(this.callScrollToId);   
    },
    methods:{
      ...mapMutations(['scrollToId']),
      ...mapActions(['getUserInfo']),
      callScrollToId(){
        const scrollToId = this.$store.state.pages.home.scrollToId;
        if(scrollToId){
          const offsetTop = document.querySelector(scrollToId).offsetTop;
          if(offsetTop > 0) {
            window.scrollTo(window.pageXOffset, offsetTop - 238); 
          }
          this.scrollToId('')
        }
      },
      async getCms(){
        this.cms = await this.$store.dispatch('pages/home/getCmsHome');
        this.$nextTick(this.callScrollToId); 
      }
    },
    computed:{
      ...mapState(['Anchor'])
    }
  }
